import { useTheme } from '@material-ui/core/styles';

import TourArrow from './TourArrow';

// Shared with the campaign extra-touch walkthrough.
const useTourAppearance = () => {
  const theme = useTheme();
  return {
    arrowComponent: TourArrow,
    options: {
      arrowBase: 24,
      arrowSize: 12,
      arrowSpacing: 20,
      arrowColor: theme.palette.white.main,
      backgroundColor: theme.palette.white.main,
      overlayColor: 'rgba(23, 23, 24, 0.18)',
      primaryColor: theme.palette.primary.main,
      zIndex: 1200,
    },
    styles: { overlay: { zIndex: 1100 }, arrow: { zIndex: 1 } },
  };
};

export default useTourAppearance;
